var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_696)",
    filter: "url(#filter0_d_9_696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5339 9.99854C13.0862 9.99854 13.5339 9.55082 13.5339 8.99854C13.5339 8.44625 13.0862 7.99854 12.5339 7.99854C11.9817 7.99854 11.5339 8.44625 11.5339 8.99854C11.5339 9.55082 11.9817 9.99854 12.5339 9.99854Z",
    fill: "#5D2EDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4934 9.99854C17.0457 9.99854 17.4934 9.55082 17.4934 8.99854C17.4934 8.44625 17.0457 7.99854 16.4934 7.99854C15.9411 7.99854 15.4934 8.44625 15.4934 8.99854C15.4934 9.55082 15.9411 9.99854 16.4934 9.99854Z",
    fill: "#5D2EDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5339 15.9565C16.7164 15.9565 18.4924 14.1815 18.4924 12H16.4924C16.4924 13.0785 15.6139 13.9565 14.5339 13.9565C13.4539 13.9565 12.5754 13.0785 12.5754 12H10.5754C10.5754 14.1815 12.3514 15.9565 14.5339 15.9565Z",
    fill: "#5D2EDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1769 9.5145C22.0949 5.7585 18.6334 3 14.5339 3C10.4344 3 6.97294 5.7585 5.89094 9.5145C5.13344 9.5885 4.53394 10.224 4.53394 11V13C4.53394 13.825 5.20894 14.5 6.03394 14.5C6.85894 14.5 7.53394 13.825 7.53394 13V11.999C7.53444 8.1395 10.6744 5 14.5339 5C18.3939 5 21.5339 8.14 21.5339 12C21.5339 15.86 18.3939 19 14.5339 19H13.5269C12.7019 19 12.0269 19.675 12.0269 20.5C12.0269 21.325 12.7019 22 13.5269 22H15.5339C16.3099 22 16.9459 21.4005 17.0194 20.643C19.9849 19.7885 22.3224 17.451 23.1769 14.4855C23.9344 14.412 24.5339 13.776 24.5339 13V11C24.5339 10.224 23.9344 9.588 23.1769 9.5145Z",
    fill: "#5D2EDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_696",
    x: -1.50757,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_696",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(2.49243)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSvgrepoCom1);
export default __webpack_public_path__ + "static/media/service-svgrepo-com 1.6b2475e3823bb2e27f97cd1f085dcb4b.svg";
export { ForwardRef as ReactComponent };